module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "icon-cross icon-x",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _vm._l((Object.keys(_vm.message)), function(type) {
    return (_vm.message[type] && _vm.message[type].length) ? _c('div', {
      staticClass: "l-row"
    }, [_c('div', {
      staticClass: "margin"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t((type + ".label"))))]), _vm._v(" "), _c('div', {
      staticClass: "l-col-12@md"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.getMessageStatus(_vm.message[type]))
      }
    })])])]) : _vm._e()
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0790e7bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/StatusMessageCard.vue
// module id = 2884
// module chunks = 0